import styles from "./EditResume.module.scss";

function EditResume() {
  return <div className={styles.maincontainer}>Edit Resume</div>;
}
export default EditResume;
